export default __webpack_public_path__ + "static/media/sbo-icon.67088452.webp";